module.exports = "/images/pandemic@3x.png?856bdab5c545207c6f8fd75b29448ba5";